module.exports = __webpack_public_path__ + "img/f59b0eca9c6426ee767050bf26e9e7c0.svg";